export class BadgesModel{
  userInfo: any = {};
  badges: any = [];
}
